import { CHAIN_USDC_ADDRESSES, CHAIN_WETH_ADDRESSES } from "../../tokens.js";
import { TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { AAVE_V3_COLLECTOR, BSC_USDC_ALLOWANCE_OWNER, BSC_USDC_ALLOWANCE_SPENDER, ERC20_BALANCE_OF_REFERENCE_CALLDATA, SWAP_QUOTE_AMOUNT, } from "../fixture-inputs.js";
export const BSC_TEST_CONFIG = {
    balance: { address: VITALIK },
    tokenBalance: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.bsc,
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "getBlockByNumberBsc",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "getBalanceBsc",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.bsc,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "getTokenBalanceBsc",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.bsc,
        fixture: "getBlockByHashBsc",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "getBlockTransactionsBsc",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "getTransfersBsc",
    },
    simulateCallQuery: {
        to: CHAIN_USDC_ADDRESSES.bsc,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "simulateCallBsc",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.bsc,
        fixture: "traceTransactionBsc",
    },
    tokenMetadataQuery: {
        address: CHAIN_USDC_ADDRESSES.bsc,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "getTokenMetadataBsc",
    },
    tokenAllowanceQuery: {
        token: CHAIN_USDC_ADDRESSES.bsc,
        owner: BSC_USDC_ALLOWANCE_OWNER,
        spender: BSC_USDC_ALLOWANCE_SPENDER,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "getTokenAllowanceBsc",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.bsc,
        fixture: "getReceiptBsc",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.bsc,
        fixture: "getTransactionByHashBsc",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasBsc",
    },
    codeQuery: {
        address: CHAIN_USDC_ADDRESSES.bsc,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc,
        fixture: "getCodeBsc",
    },
    logsQuery: {
        address: CHAIN_USDC_ADDRESSES.bsc,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.bsc),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.bsc),
        fixture: "getLogsBsc",
    },
    aaveV3Query: { address: AAVE_V3_COLLECTOR.bsc, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc, fixture: "getAaveV3UserPositionsBsc" },
    morphoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc, fixture: "getMorphoUserPositionsBsc" },
    approvalsQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc, fixture: "getApprovalsBsc" },
    pendleV2InfoQuery: { fixture: "getPendleV2InfoBsc" },
    uniswapV3QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.bsc, tokenOut: CHAIN_USDC_ADDRESSES.bsc, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc, fixture: "getUniswapV3QuoteBsc" },
    uniswapV4QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.bsc, tokenOut: CHAIN_USDC_ADDRESSES.bsc, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.bsc, fixture: "getUniswapV4QuoteBsc" },
};
